// extracted by mini-css-extract-plugin
export default {"products":"lu-z","card":"mu-z","oosMessaging":"nu-z"};